import { Pipe, PipeTransform } from '@angular/core';
import { IProduct } from '@bca-shared/models/product';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY, forkJoin as ForkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({ name: 'displayServices' })
export class DisplayServicesPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}

  transform(product: IProduct): Observable<string> {
    if (!(product && product.services)) {
      return EMPTY;
    }

    const services = product.services
      .filter(service => service.selected)
      .map(({ identifier }) => {
        return this._translate.get(
          `COMPOSE.CHOOSE_EXTRAS.SERVICES.${identifier}.TITLE`
        ) as Observable<string>;
      });

    return ForkJoin(services).pipe(map(translation => translation.join(', ')));
  }
}
